var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 82,
    viewBox: "0 0 395 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.381 0H12.191V8.161H24.381V0ZM77.171 24.38H215.399V0H32.543V8.161H40.601V16.323H24.381V24.381H44.733V32.542H48.763V40.704H32.543V48.762H93.495V56.923H32.543V65.084H40.601V73.143H44.733V81.303H125.933V32.543H77.172L77.171 24.38ZM16.22 16.323H0V24.381H16.22V16.323ZM24.381 32.543H8.161V40.703H24.381V32.543ZM12.604 65.084V73.143H24.794V65.084H12.604ZM36.984 73.143H28.824V81.303H36.984V73.143ZM215.399 81.303V32.543H182.856V60.953H166.638V32.543H134.096V81.303H215.399Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.806 0H223.663V81.304H296.806L304.967 73.143V8.16199L296.806 0ZM272.425 56.923H256.205V24.382H272.425V56.923Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.232 81.304H394.535V0H313.232V81.304ZM345.774 24.381H361.994V56.923H345.774V24.381Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d68c9cec1bc3b284b28d2d378bdc2c39.svg";
export { ForwardRef as ReactComponent };